'use strict';

exports.__esModule = true;
exports.EditableView = exports.EditableObject = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp; // import Grid from 'material-ui/Grid';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Button = require('material-ui/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ModeEdit = require('material-ui-icons/ModeEdit');

var _ModeEdit2 = _interopRequireDefault(_ModeEdit);

var _Restore = require('material-ui-icons/Restore');

var _Restore2 = _interopRequireDefault(_Restore);

var _Save = require('material-ui-icons/Save');

var _Save2 = _interopRequireDefault(_Save);

var _Snackbar = require('material-ui/Snackbar');

var _Snackbar2 = _interopRequireDefault(_Snackbar);

var _Progress = require('material-ui/Progress');

var _ = require('../');

var _2 = _interopRequireDefault(_);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SaveIcon = function SaveIcon() {
  return _react2.default.createElement(_Save2.default, {
    style: {
      color: "red"
    }
  });
};

var EditableObject = exports.EditableObject = (_temp = _class = function (_View) {
  _inherits(EditableObject, _View);

  function EditableObject(props) {
    _classCallCheck(this, EditableObject);

    var _this = _possibleConstructorReturn(this, _View.call(this, props));

    _objectDestructuringEmpty(props);

    _this.state = _extends({}, _this.state, {
      inEditMode: false,
      notifications: [],
      loading: false
    });
    return _this;
  }

  EditableObject.prototype.componentWillMount = function componentWillMount() {
    var _props$_dirty = this.props._dirty,
        _dirty = _props$_dirty === undefined ? null : _props$_dirty;

    var cache = this.getCache();
    Object.assign(this.state, {
      _dirty: _dirty || cache ? _extends({}, _dirty, cache) : undefined
    });
    return _View.prototype.componentWillMount ? _View.prototype.componentWillMount.call(this) : true;
  };

  EditableObject.prototype.getCacheKey = function getCacheKey() {
    var _props = this.props,
        cacheKey = _props.cacheKey,
        cacheKeyPrefix = _props.cacheKeyPrefix;

    var _ref = this.getObject() || {},
        id = _ref.id;

    return cacheKey !== undefined ? cacheKey : id ? '' + cacheKeyPrefix + id : null;
  };

  EditableObject.prototype.setCache = function setCache(data) {
    var localStorage = this.context.localStorage;

    if (!localStorage) {
      return false;
    }

    var cacheData = void 0;
    var key = this.getCacheKey();

    if (key) {
      try {
        if (data) {
          cacheData = JSON.stringify(data);
          localStorage.setItem(key, cacheData);
        } else {
          localStorage.removeItem(key);
        }
      } catch (error) {}
    }
  };

  EditableObject.prototype.getCache = function getCache() {
    var localStorage = this.context.localStorage;
    var cacheData = void 0;
    var key = this.getCacheKey();

    if (key && localStorage) {
      try {
        cacheData = localStorage.getItem(key);

        if (cacheData) {
          cacheData = JSON.parse(cacheData);
        }
      } catch (error) {}
    } // console.log("getCacheKey", cacheData);


    return cacheData;
  };

  EditableObject.prototype.clearCache = function clearCache() {
    var localStorage = this.context.localStorage;
    var key = this.getCacheKey();

    if (key && localStorage) {
      localStorage.removeItem(key);
    }
  };

  EditableObject.prototype.save = function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee() {
      var _this2 = this;

      var _dirty;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _dirty = this.state._dirty;
              _context.next = 3;
              return this.saveObject(_dirty).then(function (result) {
                // console.log("Save result", result);
                if (result && !(result instanceof Error)) {
                  _this2.clearCache();

                  var onSave = _this2.props.onSave;
                  var callback = void 0;

                  if (onSave) {
                    callback = function callback() {
                      return onSave(result);
                    };
                  }

                  _this2.setState({
                    _dirty: null,
                    inEditMode: false
                  }, callback);
                }

                return result;
              }).catch(function (error) {
                console.error("Save error", error);
                return error;
              });

            case 3:
              return _context.abrupt('return', _context.sent);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function save() {
      return _ref2.apply(this, arguments);
    }

    return save;
  }(); // async save() {
  //   const {
  //     _dirty,
  //     loading,
  //   } = this.state;
  //   const {
  //     client,
  //   } = this.context;
  //   if (loading) {
  //     return;
  //   }
  //   return new Promise((resolve, reject) => {
  //     this.setState({
  //       loading: true,
  //     }, async () => {
  //       let newState = {
  //         loading: false,
  //       };
  //       const result = await this.saveObject(_dirty)
  //         .then(async result => {
  //           // console.log("await this.saveObject 2", typeof result, result instanceof Error, result);
  //           if (result instanceof Error) {
  //             // console.log("await this.saveObject result", result);
  //           }
  //           else {
  //             const {
  //               data: resultData,
  //             } = result || {};
  //             const {
  //               response,
  //             } = resultData || {};
  //             // console.log("result", result);
  //             // console.log("resultData", resultData);
  //             let {
  //               success,
  //               message,
  //               errors = null,
  //               ...other
  //             } = response || {};
  //             Object.assign(newState, {
  //               errors,
  //             });
  //             if (success === undefined) {
  //               success = true;
  //             }
  //             if (!success) {
  //               this.addError(message || "Request error");
  //               // errors && errors.map(error => {
  //               //   this.addError(error);
  //               // });
  //             }
  //             else {
  //               Object.assign(newState, {
  //                 _dirty: null,
  //                 inEditMode: false,
  //               });
  //               this.clearCache();
  //               // await client.resetStore();
  //               // await client.cache.reset();
  //               // console.log("client.cache.clearStore");
  //               await client.clearStore().catch(console.error);
  //               await client.reFetchObservableQueries().catch(console.error);
  //               const {
  //                 onSave,
  //               } = this.props;
  //               if (onSave) {
  //                 onSave(result);
  //               }
  //             }
  //           }
  //           return result;
  //         })
  //         .catch(e => {
  //           console.error(e);
  //           return e;
  //         });
  //       this.setState(newState, () => {
  //         return resolve(result);
  //       });
  //       return;
  //     });
  //   });
  // }


  EditableObject.prototype.saveObject = function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee2(data) {
      var options;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // const {
              //   object,
              //   saveObject,
              // } = this.props;
              // if(saveObject){
              //   return saveObject(data);
              // }
              // console.log("saveObject data", data);
              // const {
              //   mutate,
              // } = this.props;
              // if (!mutate) {
              //   throw (new Error("Mutate not defined"));
              // }
              options = this.getMutation(data);
              return _context2.abrupt('return', this.mutate(options));

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function saveObject(_x) {
      return _ref3.apply(this, arguments);
    }

    return saveObject;
  }(); // async mutate___(options = {}) {
  //   const {
  //     mutation,
  //   } = this.props;
  //   console.log("mutation", mutation);
  //   console.log("options", options);
  //   const {
  //     client,
  //   } = this.context;
  //   return client.mutate({
  //     mutation,
  //     options: {
  //       ...options,
  //     }
  //   })
  //     .catch(error => {
  //       console.error("request error", error);
  //       const message = error.message && error.message.replace(/^GraphQL error: */, '') || "";
  //       this.addError(message);
  //     })
  // }


  EditableObject.prototype.mutate = function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee5(props) {
      var _this3 = this;

      var loading, client;
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              loading = this.state.loading;
              client = this.context.client;

              if (!loading) {
                _context5.next = 4;
                break;
              }

              return _context5.abrupt('return');

            case 4:
              return _context5.abrupt('return', new Promise(function (resolve, reject) {
                // console.log("mutate props", props);
                var _props2 = _this3.props,
                    mutate = _props2.mutate,
                    mutation = _props2.mutation;

                if (mutation && !props.mutation) {
                  props.mutation = mutation;
                }

                if (!mutate) {
                  var _client = _this3.context.client;
                  mutate = _client.mutate;
                } // console.log("mutate", mutate);


                if (!mutate) {
                  throw new Error("Mutate is not defined");
                }

                _this3.setState({
                  loading: true
                }, _asyncToGenerator(
                /*#__PURE__*/
                _regenerator2.default.mark(function _callee4() {
                  var newState, result;
                  return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          newState = {
                            loading: false
                          };
                          _context4.next = 3;
                          return mutate(props).then(function () {
                            var _ref6 = _asyncToGenerator(
                            /*#__PURE__*/
                            _regenerator2.default.mark(function _callee3(result) {
                              var _ref7, resultData, _ref8, response, _ref9, success, message, _ref9$errors, errors, other;

                              return _regenerator2.default.wrap(function _callee3$(_context3) {
                                while (1) {
                                  switch (_context3.prev = _context3.next) {
                                    case 0:
                                      if (!(result instanceof Error)) {
                                        _context3.next = 3;
                                        break;
                                      }

                                      _context3.next = 15;
                                      break;

                                    case 3:
                                      _ref7 = result || {}, resultData = _ref7.data;
                                      _ref8 = resultData || {}, response = _ref8.response; // console.log("result", result);
                                      // console.log("resultData", resultData);

                                      _ref9 = response || {}, success = _ref9.success, message = _ref9.message, _ref9$errors = _ref9.errors, errors = _ref9$errors === undefined ? null : _ref9$errors, other = _objectWithoutProperties(_ref9, ['success', 'message', 'errors']);
                                      Object.assign(newState, {
                                        errors: errors
                                      });

                                      if (success === undefined) {
                                        success = true;
                                      }

                                      if (success) {
                                        _context3.next = 13;
                                        break;
                                      }

                                      _this3.addError(message || "Request error"); // errors && errors.map(error => {
                                      //   this.addError(error);
                                      // });
                                      // result = new Error(message || "Request error", result);


                                      return _context3.abrupt('return', reject(result));

                                    case 13:
                                      _context3.next = 15;
                                      return client.resetStore().catch(console.error);

                                    case 15:
                                      return _context3.abrupt('return', result);

                                    case 16:
                                    case 'end':
                                      return _context3.stop();
                                  }
                                }
                              }, _callee3, _this3);
                            }));

                            return function (_x3) {
                              return _ref6.apply(this, arguments);
                            };
                          }()).catch(function (error) {
                            var message = error.message && error.message.replace(/^GraphQL error: */, '') || "";

                            _this3.addError(message);

                            return error;
                          });

                        case 3:
                          result = _context4.sent;

                          _this3.setState(newState, function () {
                            return resolve(result);
                          });

                          return _context4.abrupt('return');

                        case 6:
                        case 'end':
                          return _context4.stop();
                      }
                    }
                  }, _callee4, _this3);
                })));
              }));

            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function mutate(_x2) {
      return _ref4.apply(this, arguments);
    }

    return mutate;
  }(); // prepareRequest() {
  //   const {
  //     mutate,
  //   } = this.props;
  //   if (!mutate) {
  //     throw (new Error("Mutate not defined"));
  //   }
  //   return mutate;
  // }


  EditableObject.prototype.getMutation = function getMutation(data) {
    var variables = this.getMutationVariables(data);
    return {
      variables: variables
    };
  };

  EditableObject.prototype.getMutationVariables = function getMutationVariables(data) {
    var object = this.getObjectWithMutations();

    var _ref10 = object || {},
        id = _ref10.id;

    var where = id ? {
      id: id
    } : undefined;
    return {
      where: where,
      data: data
    };
  };

  EditableObject.prototype.startEdit = function startEdit() {
    this.setState({
      inEditMode: true
    });
  };

  EditableObject.prototype.resetEdit = function resetEdit() {
    var _this4 = this;

    return new Promise(function (resolve) {
      _this4.clearCache();

      _this4.setState({
        inEditMode: false,
        _dirty: null
      }, resolve);
    });
  };

  EditableObject.prototype.isInEditMode = function isInEditMode() {
    var _state = this.state,
        inEditMode = _state.inEditMode,
        _dirty = _state._dirty;
    return inEditMode || _dirty ? true : false;
  };

  EditableObject.prototype.isDirty = function isDirty() {
    return this.state._dirty ? true : false;
  }; // onChange(event) {
  //   const {
  //     name,
  //     value,
  //   } = event.target;
  //   // console.log("onChange", name, value);
  //   this.updateObject({
  //     [name]: value,
  //   });
  // }
  // updateObject(data) {
  //   const {
  //     _dirty = {},
  //   } = this.state;
  //   const {
  //     localStorage,
  //   } = this.context;
  //   const newData = Object.assign({ ..._dirty }, data);
  //   const key = this.getCacheKey();
  //   if (key && newData && localStorage) {
  //     localStorage.setItem(this.getCacheKey(), JSON.stringify(newData));
  //   }
  //   this.setState({
  //     _dirty: newData,
  //   });
  // }


  EditableObject.prototype.updateObject = function updateObject(data) {
    var _state$_dirty = this.state._dirty,
        _dirty = _state$_dirty === undefined ? {} : _state$_dirty;

    var localStorage = this.context.localStorage;
    var newData = Object.assign(_extends({}, _dirty), data);
    var key = this.getCacheKey();

    if (key && newData && localStorage) {
      localStorage.setItem(this.getCacheKey(), JSON.stringify(newData));
    }

    this.state._dirty = newData;
    this.forceUpdate();
  };

  EditableObject.prototype.getEditor = function getEditor(props) {
    var _this5 = this;

    var Editor = props.Editor,
        name = props.name,
        helperText = props.helperText,
        _onFocus = props.onFocus,
        _props$fullWidth = props.fullWidth,
        fullWidth = _props$fullWidth === undefined ? true : _props$fullWidth,
        label = props.label,
        other = _objectWithoutProperties(props, ['Editor', 'name', 'helperText', 'onFocus', 'fullWidth', 'label']);

    var object = this.getObjectWithMutations();

    if (!object) {
      return null;
    }

    var value = object[name] || "";
    var errors = this.state.errors;
    var error = errors ? errors.find(function (n) {
      return n.key === name;
    }) : "";
    var helperTextMessage = error && error.message || helperText;
    return Editor ? _react2.default.createElement(Editor, _extends({
      onChange: function onChange(event) {
        _this5.onChange(event);
      },
      name: name,
      value: value,
      style: fullWidth ? {
        width: "100%"
      } : undefined,
      label: label ? this.lexicon(label) : label,
      error: error ? true : false,
      helperText: helperTextMessage ? this.lexicon(helperTextMessage) : helperTextMessage,
      onFocus: function onFocus(event) {
        if (error) {
          var index = errors.indexOf(error);

          if (index !== -1) {
            errors.splice(index, 1);

            _this5.setState({
              errors: errors
            });
          }
        }

        return _onFocus ? _onFocus(event) : null;
      },
      fullWidth: fullWidth
    }, other)) : null;
  };

  EditableObject.prototype.getTextField = function getTextField() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    props = _extends({
      Editor: _TextField2.default,
      autoComplete: "off"
    }, props);
    return this.getEditor(props);
  };

  EditableObject.prototype.getObjectWithMutations = function getObjectWithMutations() {
    var object = this.getObject();

    if (!object) {
      return object;
    }

    var _dirty = this.state._dirty;

    if (_dirty) {
      var draftObject = _extends({}, object);

      return Object.assign(draftObject, _dirty);
    } else {
      return object;
    }
  };

  EditableObject.prototype.getObject = function getObject() {
    var _props3 = this.props,
        data = _props3.data,
        object = _props3.object; // const {
    //   object,
    // } = data || {};

    return object !== undefined ? object : data && data.object || null;
  };

  EditableObject.prototype.getButtons = function getButtons() {
    var loading = this.state.loading;
    var SaveIcon = this.props.SaveIcon;
    var inEditMode = this.isInEditMode();
    var isDirty = this.isDirty();
    var buttons = [];

    if (this.canEdit()) {
      if (inEditMode) {
        buttons.push(this.renderResetButton());

        if (isDirty) {
          buttons.push(this.renderSaveButton());
        }
      } else {
        buttons.push(this.renderEditButton());
      }
    }

    return buttons && buttons.length ? buttons : null;
  };

  EditableObject.prototype.renderResetButton = function renderResetButton() {
    var _this6 = this;

    var ResetIcon = this.props.ResetIcon;
    return _react2.default.createElement(_IconButton2.default, {
      key: 'reset',
      onClick: function onClick(event) {
        _this6.resetEdit();
      }
    }, _react2.default.createElement(ResetIcon, null));
  };

  EditableObject.prototype.renderSaveButton = function renderSaveButton() {
    var _this7 = this;

    var SaveIcon = this.props.SaveIcon;
    var loading = this.state.loading;
    return _react2.default.createElement(_IconButton2.default, {
      key: 'save',
      onClick: function onClick(event) {
        _this7.save();
      },
      disabled: loading
    }, loading ? _react2.default.createElement(_Progress.CircularProgress, null) : _react2.default.createElement(SaveIcon, null));
  };

  EditableObject.prototype.renderEditButton = function renderEditButton() {
    var _this8 = this;

    var EditIcon = this.props.EditIcon;
    return _react2.default.createElement(_IconButton2.default, {
      key: 'edit',
      onClick: function onClick(event) {
        _this8.startEdit();
      }
    }, _react2.default.createElement(EditIcon, null));
  };

  EditableObject.prototype.getTitle = function getTitle() {
    // const {
    //   object,
    // } = this.props;
    var object = this.getObjectWithMutations();

    var _ref11 = object || {},
        name = _ref11.name;

    return name;
  };

  EditableObject.prototype.renderHeader = function renderHeader() {
    return _react2.default.createElement(_Typography2.default, {
      variant: 'title'
    }, this.getTitle(), this.getButtons());
  };

  EditableObject.prototype.renderEmpty = function renderEmpty() {
    return null;
  };

  EditableObject.prototype.renderDefaultView = function renderDefaultView() {
    return null;
  };

  EditableObject.prototype.renderEditableView = function renderEditableView() {
    return null;
  }; // addError(error) {
  //   const {
  //     errorDelay,
  //   } = this.props;
  //   if (typeof error !== "object") {
  //     error = {
  //       message: error,
  //     };
  //   }
  //   Object.assign(error, {
  //     _id: new Date().getTime(),
  //   });
  //   const {
  //     notifications: oldNotifications,
  //   } = this.state;
  //   let notifications = (oldNotifications || []).slice(0);
  //   notifications.push(error);
  //   setTimeout(() => this.removeError(error), errorDelay);
  //   this.setState({
  //     notifications,
  //   });
  //   return error;
  // }
  // removeError(error) {
  //   const {
  //     notifications: oldNotifications,
  //   } = this.state;
  //   if (oldNotifications && oldNotifications.length) {
  //     const notifications = oldNotifications.slice(0);
  //     const index = notifications.indexOf(error);
  //     if (index !== -1) {
  //       notifications.splice(index, 1);
  //       this.setState({
  //         notifications,
  //       });
  //     }
  //   }
  // }


  EditableObject.prototype.closeError = function closeError(error) {
    // let {
    //   errors,
    // } = this.state;
    Object.assign(error, {
      open: false
    }); // console.log("click event 2", error, this.state.notifications);

    this.forceUpdate();
  }; // onCloseError(error) {
  //   let {
  //     notifications,
  //   } = this.state;
  //   if (!notifications) {
  //     return;
  //   }
  //   const index = notifications.indexOf(error);
  //   if (index !== -1) {
  //     notifications.splice(index, 1);
  //     this.setState({
  //       notifications,
  //     });
  //   }
  // }
  // renderErrors() {
  //   const {
  //     errorDelay,
  //   } = this.props;
  //   const {
  //     notifications,
  //   } = this.state;
  //   if (notifications && notifications.length) {
  //     let output = null;
  //     let errors = notifications.map((error, index) => {
  //       let {
  //         _id,
  //         message,
  //         open = true,
  //       } = error;
  //       return <Snackbar
  //         key={_id}
  //         open={open}
  //         autoHideDuration={errorDelay}
  //         SnackbarContentProps={{
  //         }}
  //         anchorOrigin={{
  //           vertical: "top",
  //           horizontal: "center",
  //         }}
  //         message={<span
  //         // id="snackbar-fab-message-id"
  //         >
  //           {message}
  //         </span>}
  //         action={
  //           <Fragment>
  //             <Button
  //               color="primary"
  //               variant="raised"
  //               size="small"
  //               onClick={event => {
  //                 // console.log("click event", event.target);
  //                 event.stopPropagation();
  //                 this.closeError(error)
  //               }}
  //             >
  //               Отмена
  //           </Button>
  //           </Fragment>
  //         }
  //       />
  //     });
  //     const {
  //       document,
  //     } = global;
  //     if (document.createRange) {
  //       output = ReactDOM.createPortal(<Fragment
  //       >
  //         {errors}
  //       </Fragment>, window.document.body);
  //     }
  //     else {
  //       output = errors;
  //     }
  //     return output;
  //   }
  //   else {
  //     return null;
  //   }
  // }


  EditableObject.prototype.render = function render() {
    var data = this.props.data; // if (!data) {
    //   return null;
    // }

    var _ref12 = data || {},
        loading = _ref12.loading;

    var output = null;
    var object = this.getObject();

    if (!object) {
      if (loading) {
        return null;
      } else {
        output = this.renderEmpty();
      }
    } else {
      var inEditMode = this.isInEditMode();
      var content = null;

      if (inEditMode) {
        content = this.renderEditableView();
      } else {
        content = this.renderDefaultView();
      }

      output = _react2.default.createElement(_react.Fragment, null, this.renderHeader(), content);
    } // return super.render(output);


    return _react2.default.createElement(_react.Fragment, null, output, this.renderErrors());
  };

  return EditableObject;
}(_2.default), _class.propTypes = _extends({}, _2.default.propTypes, {
  // mutate: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  mutate: _propTypes2.default.func,
  mutation: _propTypes2.default.object,
  _dirty: _propTypes2.default.object,
  errorDelay: _propTypes2.default.number.isRequired,
  SaveIcon: _propTypes2.default.func.isRequired,
  ResetIcon: _propTypes2.default.func.isRequired,
  EditIcon: _propTypes2.default.func.isRequired,
  cacheKey: _propTypes2.default.string,
  cacheKeyPrefix: _propTypes2.default.string.isRequired
}), _class.defaultProps = _extends({}, _2.default.defaultProps, {
  errorDelay: 5000,
  SaveIcon: SaveIcon,
  ResetIcon: _Restore2.default,
  EditIcon: _ModeEdit2.default,
  cacheKeyPrefix: "item_"
}), _temp);
/**
 * For backward compatibility
 */

var EditableView = exports.EditableView = EditableObject;
exports.default = EditableObject;